import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/user/user-partners?${stringify(params)}`);
}

export async function get(id, params = {}) {
  console.log(`🚀 ~ file: userPartners.js ~ line 9 ~ params`, params);
  return request(`/user/user-partner?${stringify(params)}`);
}

export async function create(body) {
  return request(`/user/user-partners`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/user/user-partners`, {
    method: 'POST',
    body,
  });
}
export async function createUserAlias(body) {
  return request(`/user/alias`, {
    method: 'POST',
    body,
  });
}
